import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: {
      customProperties: true
    },
    icons: {
      iconfont: 'mdi'
    },
    themes: {
      light: {
        primary: '#EE8C32',
        secondary: '#585858',
        blue: '#527BAE',
        greyBlue: '#6792C9',
        orange: '#FFBB63',
        orange2: '#FEAA3C',
        orange3: '#FFEAD1',
        grassGreen: '#7EBE50',
        white: '#FFFFFF'
      }
    }
  }
})
